import React, { useState } from "react";
import { Share2, MessageCircle, Linkedin, Facebook, Mail, Link2, Check } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { toast } from "sonner";

export const jobShareUrl = (id) => `${window.location.origin}/jobs/${id}`;

const shareText = (job, url) =>
  `*${job.title}*${job.company_name ? ` — ${job.company_name}` : ""}\n` +
  `Location: ${job.location}\nExperience: ${job.experience_min}-${job.experience_max} yrs\n` +
  `Industry: ${job.industry}\n\nApply here: ${url}\n\n— Achievers Enterprise, Ahmedabad`;

const stop = (e) => e.stopPropagation();

export default function ShareJob({ job, triggerClassName = "", label = "Share", testid = "share-job" }) {
  const [copied, setCopied] = useState(false);
  const url = jobShareUrl(job.id);
  const text = shareText(job, url);
  const enc = encodeURIComponent;
  const options = [
    { k: "whatsapp", l: "WhatsApp", icon: MessageCircle, cls: "text-emerald-600", href: `https://wa.me/?text=${enc(text)}` },
    { k: "linkedin", l: "LinkedIn", icon: Linkedin, cls: "text-[#0A66C2]", href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}` },
    { k: "facebook", l: "Facebook", icon: Facebook, cls: "text-[#1877F2]", href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { k: "email", l: "Email", icon: Mail, cls: "text-[#0F2A4A]", href: `mailto:?subject=${enc(`Job Opening: ${job.title}`)}&body=${enc(text.replace(/\*/g, ""))}` },
  ];

  const copy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    toast.success("Job link copied");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <Popover>
      {/* wrapper blocks navigation when nested inside a card <Link>, after Radix has toggled */}
      <span className="contents" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
        <PopoverTrigger asChild>
          <button type="button" className={triggerClassName} data-testid={`${testid}-btn`}>
            <Share2 className="w-4 h-4" />{label && <span>{label}</span>}
          </button>
        </PopoverTrigger>
      </span>
      <PopoverContent align="end" className="w-56 p-2 bg-white" onClick={stop} data-testid={`${testid}-menu`}>
        <div className="px-2 py-1.5 text-[10px] uppercase tracking-wider font-semibold text-slate-400">Share this job</div>
        {options.map(o => (
          <a key={o.k} href={o.href} target="_blank" rel="noreferrer" data-testid={`${testid}-${o.k}`}
            className="flex items-center gap-3 px-2 py-2 rounded-lg text-sm text-slate-700 hover:bg-slate-50 transition-colors">
            <o.icon className={`w-4 h-4 ${o.cls}`} /> {o.l}
          </a>
        ))}
        <button type="button" onClick={copy} data-testid={`${testid}-copy`}
          className="w-full flex items-center gap-3 px-2 py-2 rounded-lg text-sm text-slate-700 hover:bg-slate-50 transition-colors">
          {copied ? <Check className="w-4 h-4 text-emerald-600" /> : <Link2 className="w-4 h-4 text-[#C5A059]" />}
          {copied ? "Copied!" : "Copy Link"}
        </button>
      </PopoverContent>
    </Popover>
  );
}
